<template>
  <div
    id="seasidetms_row_38ek9y5fzh"
    class="seasidetms_row seasidetms_color_scheme_default seasidetms_row_top_default seasidetms_row_bot_default seasidetms_row_boxed"
  >
    <div class="seasidetms_row_outer_parent">
      <div class="seasidetms_row_outer">
        <div class="seasidetms_row_inner">
          <div class="seasidetms_row_margin seasidetms_11">
            <router-link
              :to="
                lang
                  ? '/' + lang + '/product-category/used/iphone'
                  : '/product-category/used/iphone'
              "
            >
              <div
                id="seasidetms_column_s348hg2jzt"
                class="seasidetms_column one_first seasidetms_adaptive_margin_column iphone-x"
              >
                <img
                  src="/img/bu-1.png"
                  :alt="$h.getAlt('Б/У-apple')"
                  title="Б/У-apple"
                />
                <!-- <div class="seasidetms_column_inner">
                  <div
                  id="seasidetms_heading_6aedbwp0a"
                  class="seasidetms_heading_wrap seasidetms_heading_align_left"
                >
                  <div class="h3 seasidetms_heading">Innovative Technology</div>
                </div>
                  <div
                    id="seasidetms_heading_wj9ho90u3p"
                    class="seasidetms_heading_wrap seasidetms_heading_align_left"
                  >
                    <div class="h2 seasidetms_heading">
                      <router-link :to="lang ? '/' + lang + '/product-category/iphone/iphone-x' : '/product-category/iphone/iphone-x'">
                        iPhone X
                        </router-link>
                    </div>
                  </div>
                  <div
                    id="seasidetms_heading_dojrk49ls"
                    class="seasidetms_heading_wrap seasidetms_heading_align_left"
                  >
                    <div class="h6 seasidetms_heading">Цена от</div>
                  </div>
                  <div
                    id="seasidetms_heading_93tz4yvfuq"
                    class="seasidetms_heading_wrap seasidetms_heading_align_left"
                  >
                    <div class="h2 seasidetms_heading">$479</div>
                  </div>
                </div> -->
              </div>
            </router-link>
            <!-- <div
              id="seasidetms_column_gb9cnx11xe"
              class="seasidetms_column one_first seasidetms_adaptive_margin_column fadeInLeft animated one-banner-ipad"
              data-animation="fadeInLeft"
              data-delay="500"
            >
              <div class="seasidetms_column_inner">
                <div
                  id="seasidetms_heading_f5bkryu10s"
                  class="seasidetms_heading_wrap seasidetms_heading_align_left"
                >
                  <h2 class="seasidetms_heading">
                    <router-link to="/product-category/ipad">
                      Apple iPad
                    </router-link>
                  </h2>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OneBanner',
  data() {
    return {
      lang: '',
    }
  },
  beforeMount() {
    this.lang = this.$store.getters.lang
  },
  updated() {
    this.lang = this.$store.getters.lang
  },
}
</script>

<style>
#seasidetms_column_s348hg2jzt {
  background-color: #f0f0f0;
  -webkit-border-radius: 15px;
  border-radius: 15px;
  overflow: hidden;
}
.iphone-x {
  /* background-image: url(/img/bu-1.png) !important; */
  background-position: top center;
  background-repeat: no-repeat;
  background-attachment: scroll;
  background-size: cover;
}
#seasidetms_heading_93tz4yvfuq .seasidetms_heading {
  text-align: left;
}

#seasidetms_heading_93tz4yvfuq .seasidetms_heading,
#seasidetms_heading_93tz4yvfuq .seasidetms_heading a {
  font-size: 32px;
  line-height: 36px;
  font-weight: 500;
  color: #ff4300;
}
.one-banner-ipad {
  height: 183px;
  background-repeat: no-repeat !important;
  background-image: url(/img/ipad-banner.jpeg) !important;
  background-size: contain;
  background-position: right top;
}
</style>
